import allImgPaths from "assets/images";
import CustomCheckBox from "components/CustomCheckBox";
import { format } from "date-fns";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import Tooltip from "../tooltip/Tooltip";

const FavFavorites = ({ favoritesData: data, setItemIsFavorite, taskId }: any) => {
    const setFavorite = (data: any) => {
        setItemIsFavorite({ messageId: data?.messageId, taskId }, data?.title, false)
    }

    return (
        <div className="border border-[#D8D8D8] hover:shadow-xl rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 cursor-pointer">
            {
                data &&
                <div className="relative" >
                    <div className="h-[190px] rounded-tl-[10px] rounded-tr-[10px] mb-2.5">
                        <img
                            className="rounded-tl-[10px] rounded-tr-[10px] w-full h-full object-cover mb-2"
                            src={allImgPaths.dummyImg1}
                            alt=""
                        />
                    </div>
                    <h5 className="text-[#101828] font-interSemiBold text-lg px-2 pb-2 truncate max-w-96 leading-none">
                        {data?.title || 'No Title Available'}
                    </h5>
                    <p className="text-[#475467] px-2 mb-3 line-clamp-2 h-12">
                        {data?.description || data?.imageDescription || 'No description available'}
                    </p>
                    
                    {
                        data?.tags?.length &&
                        <div className="flex flex-wrap gap-1.5 mb-3 items-start h-[50px] px-2">
                            {
                                data?.tags?.slice(0, 4).map((tag: any, tagIndex: number) => (
                                    <span title={tag} key={tagIndex} className="text-xs font-interSemiBold text-[#363F72] border border-[#D5D9EB] rounded bg-[#F8F9FC] py-0.5 px-1 truncate max-w-[80px]">
                                        {tag}
                                    </span>
                                ))
                            }

                            {
                                data?.tags?.length > 4 &&
                                <div className="relative group cursor-pointer leading-[1.25]">
                                    <span className="text-xs font-interSemiBold text-[#363F72] border border-[#D5D9EB] rounded bg-[#F8F9FC] py-0.5 px-1">
                                        + {(data.tags.slice(4).length)}
                                    </span>
                                    <Tooltip list={data.tags.slice(4).map((item: any) => ({ _id: item, name: item }))} />
                                </div>
                            }
                        </div>
                    }
                    <div className="flex items-center gap-x-2 justify-between border-t border-[#EAECF0] pt-2 pb-2 px-2">
                        <div className="flex items-start gap-x-2">
                            <img
                                className="w-6 h-6 rounded-full"
                                src={allImgPaths.dummyImg}
                                alt=""
                            />
                            <div>
                                <p className="text-xs text-[#667085] pt-1">{data?.userName}</p>
                                {/* <p className="text-xs text-[#667085]">
                                        {data?.updatedAt ? format(data?.updatedAt, "MMMM d, yyyy h:mm a") : 'N/A'}
                                    </p> */}
                            </div>
                        </div>
                        <div className='flex items-center gap-x-4'>
                            <img
                                onClick={(e: any) => setFavorite(data)}
                                className='w-6 h-6 cursor-pointer on-hover-red'
                                src={
                                    data?.is_favorite ? allImgPaths.heartIconRed : allImgPaths.heartIconGrey
                                }
                                alt=''
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default FavFavorites